import { useEffect } from "react";
import useSound from "use-sound";
import WhileSolarSFX from "../lib/audio/while-solar-system.mp3";
import AfterSolarSFX from "../lib/audio/after-solar-system.mp3";

export const handleBackgroundSFX = (
  isMusicOff: any,
  music: any,
  isError: any,
  isLoading: any,
  whileSolar: any,
  disableSounds: any,
  errorText: any,
  jackpotState: any
) => {
  const [playWhileSolarSFX, { stop: stopSolar, sound: soundSolar }] = useSound(
    WhileSolarSFX,
    {
      volume: parseFloat(music) > 0 ? 0.1 : 0,
    }
  );
  const [playAfterSolarSFX, { stop: stopAfter, sound: soundAfter }] = useSound(
    AfterSolarSFX,
    {
      volume: parseFloat(music) / 100,
    }
  );

  useEffect(() => {
    if (
      whileSolar === "before-solar" &&
      jackpotState !== "initBlackHole" &&
      jackpotState !== "roundStarted" &&
      jackpotState !== "initRound"
    ) {
      !isMusicOff && !isError && !isLoading && !disableSounds
        ? (() => {
            playWhileSolarSFX();
            soundSolar && soundSolar.loop(true);
          })()
        : stopSolar();
    } else {
      stopSolar();
    }
  }, [
    isMusicOff,
    playWhileSolarSFX,
    stopSolar,
    soundSolar,
    isError,
    isLoading,
    whileSolar,
    disableSounds,
    jackpotState,
  ]);
  let timeout: any;
  useEffect(() => {
    if (jackpotState === "initJackpot") {
      timeout = setTimeout(() => {
        stopAfter();
      }, 2000);
      return;
    }
    if (
      whileSolar === "after-solar" &&
      jackpotState !== "initBlackHole" &&
      jackpotState !== "roundStarted"
    ) {
      !isMusicOff && !isError && !isLoading && !disableSounds
        ? (() => {
            playAfterSolarSFX();
            soundAfter && soundAfter.loop(true);
          })()
        : stopAfter();
    } else {
      stopAfter();
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [
    isMusicOff,
    playAfterSolarSFX,
    stopAfter,
    soundAfter,
    isError,
    isLoading,
    whileSolar,
    disableSounds,
    jackpotState,
  ]);

  useEffect(() => {
    if (errorText !== "") {
      stopSolar();
      stopAfter();
    }
  }, [errorText]);
};
